import { createSvgIcon } from "@mui/material";

export const PlacementTopRightIcon = createSvgIcon(
  <svg viewBox="0 0 12 9" fill="none">
    <path
      fill="currentColor"
      d="M11.811 7.599a.85.85 0 0 0-.844-.844H5.905a.833.833 0 0 0-.844.844c0 .448.37.844.844.844h5.062a.87.87 0 0 0 .844-.844M0 .844c0 .448.37.844.844.844h10.125a.87.87 0 0 0 .844-.844.85.85 0 0 0-.844-.844H.844A.833.833 0 0 0 0 .844m11.811 3.375a.85.85 0 0 0-.844-.844H5.905a.833.833 0 0 0-.844.844c0 .448.37.843.844.843h5.062a.87.87 0 0 0 .844-.843"
    />
  </svg>,
  "PlacementTopRightIcon",
);
